var exports = {
  "g": "BaseCell__jOnhQ_",
  "u": "ButtonBase__FALQJO",
};

module.exports = exports;
